// Hooks
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

// Redux
import { getPartnerKey, getIsPartnerValid } from '../models/referral';

export const usePartnership = () => {
    const partnerKey = useSelector(getPartnerKey);
    const isPartnerValid = useSelector(getIsPartnerValid);

    return useMemo(() => {
        return {
            partnerKey: isPartnerValid ? partnerKey : null,
            trialDuration: partnerKey && isPartnerValid ? 30 : 14,
        };
    }, [isPartnerValid, partnerKey]);
};
